import gql from "graphql-tag";

export const GET_PAYMENT_METHOD = gql`
  query paymentMethod($id: ID!) {
    paymentMethod(id: $id) {
      id
      name
    }
  },
`;
